import React from "react";
import { useCardInfo } from "@/api/hooks/use-query-api";
import { useCheckoutStore } from "../store/checkout-store";

/**
 * Aktif kart BIN'ine göre taksit seçeneklerini çeker.
 * activeBinNumber store'dan gelir:
 *   - Saklı kart seçilince: kart saklama sırasında kaydedilen binNumber
 *   - Yeni kart girilince: PaymentMethodSection kart numarasının ilk 8 hanesi
 */
export const useCheckoutCardInfo = () => {
  const {
    activeBinNumber,
    setCardInfo,
    setInstallments,
    setSelectedInstallment,
    buyNowOfferId,
    buyNowQuantity,
  } = useCheckoutStore();

  // BIN 8 hane olmalı
  const binNumber = React.useMemo(() => {
    if (!activeBinNumber) return null;
    const bin = activeBinNumber.replace(/\D/g, "").slice(0, 8);
    return bin.length === 8 ? bin : null;
  }, [activeBinNumber]);

  const buyNow = React.useMemo(
    () =>
      buyNowOfferId
        ? { offerId: buyNowOfferId, quantity: buyNowQuantity ?? 1 }
        : undefined,
    [buyNowOfferId, buyNowQuantity]
  );

  const {
    data: cardInfoData,
    isLoading: isLoadingCardInfo,
    error: cardInfoError,
  } = useCardInfo(binNumber, buyNow);

  // BIN değişince hemen eski taksitleri temizle — yeni data gelene kadar stale gösterme
  React.useEffect(() => {
    setCardInfo(null);
    setInstallments([]);
    setSelectedInstallment(null);
  }, [binNumber, setCardInfo, setInstallments, setSelectedInstallment]);

  // Yeni data gelince store'a yaz
  React.useEffect(() => {
    if (cardInfoData?.data) {
      setCardInfo(cardInfoData.data.cardInfo);
      setInstallments(cardInfoData.data.installments);
    }
  }, [cardInfoData, setCardInfo, setInstallments]);

  return {
    cardInfo: cardInfoData?.data?.cardInfo || null,
    installments: cardInfoData?.data?.installments || [],
    isLoadingCardInfo,
    cardInfoError,
    binNumber,
  };
};
